import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import map from 'lodash/map';
import { Checkbox, Input } from 'containers/form';
import Icon, { iconTypes } from 'components/icon';
import { MultiStepModal } from 'components/modal';
import Button, { btnViews, btnThemes } from 'components/button';
import Accordion from 'components/accordion';

const bemClasses = new Bem('subscribe');
const accordionMainConfig = [
  'Новости новостроек', 'Новости новостроек', 'Новости новостроек'
];
const accordionContentConfig = [
  'Акции', 'Снять квартиру', 'Снять дом', 'Аренда коммерческой', 'Цены на аренду', 'Риэлторы по аренде'
];
const socialConfig = [
  { title: 'Почта', icon: iconTypes.letter },
  { title: 'Viber', icon: iconTypes.viber },
  { title: 'Telegram', icon: iconTypes.telegram },
  { title: 'Messenger', icon: iconTypes.messenger }
];

export default class SubscribeModal extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    asideBlock: PropTypes.bool,
    inListDD: PropTypes.bool,
    title: PropTypes.string,
    label: PropTypes.string
  };

  static defaultProps = {
    title: 'Подписаться',
    label: 'Подписаться'
  };

  constructor(...args) {
    super(...args);
    this.state = {
      renderModal: false
    };
  }

  renderMainButton() {
    const { asideBlock, inListDD, title = 'Подписаться', label = 'Подписаться' } = this.props;
    const button = (
      <Button
        onClick={() => this.setState({ renderModal: true })}
        title={asideBlock ? 'Оформить подписку' : title}
        label={asideBlock ? 'Оформить подписку' : label}
        iconType={!asideBlock && iconTypes.telegram}
        dataView={!asideBlock && !inListDD && btnViews.subscribe}
        inListDD={inListDD}
      />
    );

    if (asideBlock) {
      return (
        <div {...bemClasses('subscribe', 'asideBlock')}>
          <div {...bemClasses('subscribeTopHeader')} />
          <div {...bemClasses('subscribeTop')}>
            <Icon {...bemClasses('icon')} type={iconTypes.letter} />
            <span {...bemClasses('text')}>Подпишитесь на новости от Domik.ua</span>
          </div>
          <div {...bemClasses('subscribeBottom')}>
            {button}
          </div>
        </div>
      );
    }

    return button;
  }

  renderContent({ currentStep }) {
    if (currentStep > 0) {
      return (
        <div {...bemClasses('modalContent')} key="secondStep">
          {map(socialConfig, ({ title, icon }, index) => (
            <Accordion
              key={index}
              {...bemClasses('accordion', 'subscribeSend')}
              panelTopic={title}
              panelIconType={icon}
            >
              <panel {...bemClasses('panel', icon)}>
                <div {...bemClasses('accordionContent')}>
                  <Input {...bemClasses('input')} />
                </div>
              </panel>
            </Accordion>
          ))}
        </div>
      );
    }

    return (
      <div {...bemClasses('modalContent')} key="firstStep">
        {map(accordionMainConfig, (mainAccord, key) => (
          <Accordion
            key={key}
            panelTopic={mainAccord}
            panelBefore={<Checkbox {...bemClasses('checkbox', 'panel')} noPadding noLabel noError />}
            panelTopicRight={1}
          >
            <panel>
              <div {...bemClasses('accordionContent')}>
                {map(accordionContentConfig, (item, index) => (
                  <Checkbox
                    {...bemClasses('checkbox')}
                    key={index}
                    noError
                    verticalACenter
                  >
                    {item}
                  </Checkbox>
                ))}
              </div>
            </panel>
          </Accordion>
        ))}
      </div>
    );
  }

  renderFooter(currentStep, changeStep) {
    const secondStep = currentStep > 0;
    return [
      <button
        key="Отмена"
        label="Отмена"
        onClick={secondStep ? () => changeStep(-1) : null}
        theme={btnThemes.light}
        close
      />,
      <button
        key="Ok"
        label={secondStep ? 'Готово' : 'Способ отправки'}
        onClick={!secondStep ? () => changeStep(1) : null}
        theme={btnThemes.light}
        close={secondStep}
      />
    ];
  }

  render() {
    return (
      <>
        {this.renderMainButton()}
        {this.state.renderModal &&
          <MultiStepModal
            {...bemClasses('modal')}
            renderHeader={curStep => curStep === 0 ? 'Выбор рубрик' : 'Способ отправки'}
            renderContent={this.renderContent}
            renderFooter={this.renderFooter}
            onModalClose={() => this.setState({ renderModal: false })}
            size="medium"
          />
        }
      </>
    );
  }
}
